import { useEffect } from "react";

const usePageTracker = (eventName = "page_view") => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
      });
    }
  }, [eventName]);
};

export default usePageTracker;
